import Popup from 'reactjs-popup';
import styled from 'styled-components';

const StyledPopup = styled(Popup)`
  &-overlay {
    background: rgba(0, 0, 0, 0.15); /* Dark overlay background */
  }

  &-content {
    position: fixed !important;
    top: 0;
    right: 0;
    height: 100vh;
    width: 386px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease-in-out;
    transform: translateX(100%); /* Initially hide the modal off-screen to the right */
		border:none;
		padding: .85rem 0rem 1rem 1rem;
    &.open-content {
      transform: translateX(0); /* Slide in when open */
			background:var(--sidebarBgColor);
    }

    &.close-content {
      transform: translateX(100%); /* Slide out when closed */
    }
  }
`;

export { StyledPopup };

export const ModalContent = styled.div`
`; 

export const EditFacetModalBtnWrap = styled.div`
	
	button.edit-facet-btn{
		margin-top: 3px;
		margin-bottom: .5rem;
		background: var(--btnBgdefault);
		width: 100%;
		color:var(--textTitleColor);
		font-weight: 600;
		// border: 1px solid #D6D6D6;
		font-size: 15px;
		line-height: 18px;
		cursor: pointer !important;
		padding: 10px 2rem 10px;
		border: 1px solid var(--borderColor);
    border-radius: 8px;
		gap: 8px;
		&:disabled{
			cursor: not-allowed !important;
			opacity: .6 !important;
		}
	}
	`;

export const DivPanelCount = styled.div`
		color: var(--textTitleColor);
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: .5rem;
		gap: 5px;

		label{
			font-size: 14px;
			line-height: 16px;
			font-family: 'Inter';
  		font-weight: 500;
			color: var(--textTitleColor);
		}
		&.area-sqft-wrap{
			margin-top: 5px;
			margin-bottom: 0;
			small{
				font-size: 13px;
				opacity: .9;
				font-weight: 400;
			}
		}

		span{
		 font-size: 14px;
		 line-height: 16px;
		 font-weight: 600;
		 position: relative;
		 color: var(--textHeadingColor);
		}


	`;

export const AzimuthHeading = styled.h4`
		font-family: 'Inter';
    font-weight: 500;
    color: var(--textColor);
    margin: 0 0px .5rem;
    line-height: 1.2;
    font-size: 1.125rem;

		sup{
			font-size: 65%;
			opacity:1;
		}
		span {
			margin-left: 5px;
			color: var(--labelValueColor);
			font-family: 'Inter';
			font-weight: 400;
			font-size: 1rem;
		}
	`;

export const DivPitchWrap = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 5px;
		gap: 5px;

		label{
			font-size: 14px;
			line-height: 16px;
			font-family: 'Inter';
  		font-weight: 500;
			color: var(--textTitleColor);
		}

		span{
			font-size: 14px;
		 line-height: 16px;
		 font-weight: 600;
			position: relative;
			top: 0px;
			color: var(--textColor)
		}
			sup{
				opacity:.85;
			}
`;

// export const DivFacetDetail = styled.div`
// 	padding: 1.125rem .85rem;
// 	background: #fff;
// 	box-shadow: none;
// 	border: 1px solid transparent;
// 	border-radius: 0px;
// 	margin-bottom: .815rem;
// 		&.active {
// 				background: #e3ebff;
// 		}
// 		&.edited {
// 		background: #fff;
// 		border: 1px solid #7DA2FF;

// 		&.active{
// 				background: #e3ebff;
// 		}
// 	}
// `;

export const DivFacetDetail = styled.div`
  padding: 1rem;
  background: var(--modalBgColor);
  border-radius: 12px;
  margin-bottom: 12px;
  border: 1px solid var(--borderLightColor);
  transition: all 0.25s ease;

  &:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.08);
  }

  &.active {
    background: var(--activeBgColor);
    border: 1px solid #7da2ff;
    box-shadow: 0 4px 8px rgba(125,162,255,0.25);
  }

  &.edited {
    border: 1px dashed #7DA2FF;
  }

  &.edited.active {
    background: var(--activeBgColor);
  }
`;

export const ModalFacetWrap = styled.div`
width: 100%;

`;
export const FacetWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: .75rem;
	padding-right: 1rem;
	min-height:36px;
`;

export const ModalFacetBox = styled.div`
		padding: 1rem .85rem .65rem;
    background: var(--modalBgColor);
    box-shadow: none;
		border: 1px solid var(--borderLightColor);
		transition: 0.25s;
		border-radius: 12px;
    margin-bottom: .815rem;
	
		&.active {
			background: var(--activeBgColor);
    	border: 1px solid rgb(125, 162, 255);
    	box-shadow: rgba(125, 162, 255, 0.25) 0px 4px 8px;
		

			button{
				background: var(--defaultBgColor);
			}
		}
		&.edited {
			background: var(--defaultBgColor);
			border: 1px dashed rgb(125, 162, 255);


			&.active{
					background: var(--activeBgColor);
			}
		}

`;

export const ModalFacetInfoWrap = styled.div`
		overflow-y: auto;
		height: calc(100vh - 100px);
    padding-right: .5rem;
`;
export const FacetTitle = styled.div`
		color: var(--textColor);
		font-size: 1.25rem;
		font-family: 'Inter';
		font-weight: 500;
`;

export const HeadingAzimuth = styled.div`
		font-family: 'Inter';
    color: var(--textColor);
    margin: 0 0px .5rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: 5px;

		label{
			font-size: 14px;
			line-height: 16px;
			font-family: 'Inter';
			font-weight: 500;
			color: var(--textTitleColor);
		}
		span{
			font-size: 14px;
		 	line-height: 16px;
		 	font-weight: 600;
			color: var(--textHeadingColor);
		}
		sup{
			font-size:.65rem
			font-weight: 400;
		}
`;

export const ShadingWrap = styled.div`
	margin-bottom: 7px !important;
	display: flex;
	align-items: flex-start;
	gap: 5px;
	margin-top: 8px !important;	

 label {
    color: var(--textTitleColor);
    font-family: 'Inter';
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    display: block;
  }	
	span{
		font-size: 12px;
		line-height: 16px;
		font-family: Inter;
		font-weight: 500;
		color: var(--subHeadingColor);
	}
	button {
    // box-shadow: none;
    // border: 1px solid #EFF0F7;
    // background: #EFF0F7;
    // color: #64686A;
    // font-size: 12px;
    // text-transform: capitalize;
    // line-height: 14px;
    // padding: 4px 9px;
		// border-radius: 4px;
		// font-family: 'Inter';
    // font-weight: 500;
		 border-radius: 20px;
    padding: 4px 12px;
    font-size: 12px;
		line-height: 16px;
    background: var(--btnBadge);
    border: 1px solid var(--borderLightColor);

		&.active {
				border-color: var(--primary);
				background: var(--badgeLight);
				color: var(--primary);	
		}
	}

	&:not(facet-slope-wrap) {
    margin-bottom: 10px;
	}
`;

export const FacetTitleButtons = styled.div`
		display: flex;
		gap: .5rem;

		.btn-reset{
			background: var(--defaultBgColor);
			color: var(--textTitleColor);
			border: 1px solid rgba(0,0,0,.20);
		}
`;

export const CustomShading = styled.div`
	display: flex; 
	flex-direction: row;
	align-items: center;
	margin-top: 0; 
	padding-top: 0px;
	gap:8px;
	@media (min-width: 769px) {
		position: absolute;
		bottom: 0;
		left: 76px;
	}

	button{
		box-shadow: none;
    border: 1px solid var(--toggleGroupBgColor);
    background: var(--toggleGroupBgColor);
    color: var(--subHeadingColor);
    font-size: 0.813rem;
    text-transform: capitalize;
    line-height: 1.358;
    padding: 5px 9rem;
    border-radius: 4px;
    font-family: Inter;
    font-weight: 500;
		min-height: auto;
	}

	label{
	margin-bottom: 4px;
	color: var(--subHeadingColor);
	font-weight: 500;
	font-size: .95rem;
	
	}
	input{
		width: 62px; 
		height: 27px;
		border: 1px solid var(--primary);
    border-radius: 4px;
    padding-left: 6px;
		color: #2e384de6;
		background: var(--badgeLight);
			color: var(--primary);

		&:active,
		&:focus{
			border-color: var(--primary);
			color: var(--primary);
			box-shadow: none;
			outline: none;
		}
		&.active{
			border-color: var(--primary);
			color: var(--primary);
		}	
	}
`;

export const ShadingLabel = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
	margin-bottom: 0px;
	margin-top: 0.5px;
	height: 27px;
	padding-right: 0;

	label{
			font-size: 14px;
			line-height: 16px;
			font-family: 'Inter';
  		font-weight: 500;
			color: var(--textTitleColor);
		}

	span{
		padding-bottom: 0;
		font-size: 14px;
	}
`;

export const WarningContainer = styled.div`
  background-color: var(--defaultBgLightColor);    
  border: 1px solid #fc8181;
  border-radius: 4px;
  padding: 0.75rem 1rem;
  margin-top: 0.5rem;
`;

export const WarningText = styled.p`
  color: var(--warningColor);
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
`;

export const SystemDivWrap = styled.div`
	display: flex;
  flex-wrap: wrap;
  gap: 1px 12px;

  background: var(--surfaceColor);
  padding: 10px 12px;
  border-radius: 8px;
  margin-top: 6px;
  border: none;

  &.active {
    background: var(--arrayDetailsActiveBgColor);
  }

  .array-detail-value {
		margin-bottom: 2px;
   &.array-production{
	 	width: 100%;
	 }

    label {
      font-size: 12px;
      color: var(--mutedLabelColor);
    }

    span {
      font-size: 12px;
      font-weight: 600;
    }
  }
`;

export const ArrayHeading = styled.div`
	width: 100%;
  font-size: 12px;
  font-weight: 600;
  color: var(--mutedLabelColor);
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;
export const FlexTwoCol = styled.div`
		display: grid;
		grid-template-columns: 1fr 1fr;
    gap: 8px 10px;
		width: 100%;
`;

export const HeightSpacingWrap = styled.div`
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		gap: 8px;
		flex-direction: row;
		width: 100%;

		`;